
(function($){
    $.fn.list_ticker = function(options){
      
      var defaults = {
        speed:4000,
        effect:'slide'
      };
      
      var options = $.extend(defaults, options);
      
      return this.each(function(){
        
        var obj = $(this);
        var list = obj.children();
        list.not(':first').hide();
        
        setInterval(function(){
          
          list = obj.children();
          list.not(':first').hide();
          
          var first_li = list.eq(0)
          var second_li = list.eq(1)
          
          if(options.effect == 'slide'){
              first_li.slideUp();
              second_li.slideDown(function(){
                  first_li.remove().appendTo(obj);
              });
          } else if(options.effect == 'fade'){
              first_li.fadeOut(function(){
                  second_li.fadeIn(0);
                  //first_li.remove().appendTo(obj);
                  first_li.remove();
              });
          }
        }, options.speed)
      });
    };
  })(jQuery);
/*
  window.onload = function () {
    document.body.classList.add('loaded_hiding');
    if ( $('.mainSlider').length ){
        window.setTimeout(function () {
            document.body.classList.add('loaded');
            document.body.classList.remove('loaded_hiding');
            $('#fade').css('display', 'none');
            $('.preloader').fadeOut(500);
          }, 3000);
    }
    else {
            document.body.classList.add('loaded');
            document.body.classList.remove('loaded_hiding');
            $('.preloader').fadeOut(500);

    }
    

  }
*/
/*
  $(window).load(function() {
    function Preloader() {
        document.body.classList.add('loaded_hiding');
        if ( $('.mainSlider').length ){
            window.setTimeout(function () {
                document.body.classList.add('loaded');
                document.body.classList.remove('loaded_hiding');
                $('#fade').css('display', 'none');
                $('.preloader').fadeOut(500);
            }, 3000);
        }
        else {
                document.body.classList.add('loaded');
                document.body.classList.remove('loaded_hiding');
                $('.preloader').fadeOut(500);

        }
    }
    if ( ! sessionStorage.getItem( 'doNotShow' ) ) {
        sessionStorage.setItem( 'doNotShow', true );
        //$ ('.preloader').show();
        Preloader();
    } else {
       $ ('.preloader').hide();
    }
});
*/
$(window).resize(function () {
    window_width = $(window).innerWidth();
    window_height = $(window).innerHeight();
    fixPageMinHeight();
})

function rnd(min, max) {
    var rand = min - 0.5 + Math.random() * (max - min + 1);
    rand = Math.round(rand);
    return rand;
};

function Preloader() {
    document.body.classList.add("loaded_hiding");
    
        window.setTimeout(function () {
            document.body.classList.add("loaded");
            document.body.classList.remove("loaded_hiding");
            pre.classList.add('hide2');
        }, 4500);
}

$(window).load(function() {
    $('.chzn-select').each(function () {
        // if ( $(this).find('option:first-child').text() == "Not selected" ){
        //     $(this).next().children('.chosen-single').children('span').css('color','#ccc');
        // }
        if ( $(this).val() == "" ){
            $(this).next().children('.chosen-single').children('span').css('color','#ccc');
        }
        // else {
        //     $(this).next().children('.chosen-single').children('span').css('color','#000');
        // }
    });
});    

$(document).ready(function () {

    $('input').each(function () {
        if ($(this).val() !== ''){
            $(this).parent().addClass("hover");
        }           
    });
    $('textarea').each(function () {
        if ($(this).val() !== ''){
            $(this).parent().addClass("hover");
        }           
    });
    $('.chzn-select').each(function () {
        if ( ($(this).val() !== "" || $(this).val() !== null || $(this).val() == "Not selected") ) {
            $(this).parent().addClass("active");
        }

        if ( ($(this).val() == "" || $(this).val() == null) ){
            $(this).parent().removeClass("active");
        }
        if ( $(this).find('option:first-child').text() == "Not selected" ){
            $(this).parent().addClass("active");
        }
    });






        if ( ! sessionStorage.getItem( "doNotShow" ) ) {
            sessionStorage.setItem( "doNotShow", true );
            Preloader();
        } else {
            pre.classList.add('hide');
        }


        $('#fade').list_ticker({
         speed: 0,
         effect: 'fade'
        });
 


    if ($(".loginpage").length) {
        $(".header-login-btn").addClass("active");
    }

    check_resize();
    $("label.with_line input, label.with_line textarea, .with_hover_text input, .with_hover_text textarea").focus(function () {
        $(this).parent().addClass("hover");
    });
    $("label.with_line input, label.with_line textarea, .with_hover_text input, .with_hover_text textarea").blur(function () {
        if ($(this).val() == "") {
            $(this).parent().removeClass("hover");
        }
    });

    // $("input.tel_mask").mask("+3 8 (055) 555-55-55");

    $("header .menu_btn").click(function () {
        if (menu_btn_access) {
            $(this).toggleClass("active");
            menu_btn_access = false;
            if ($(this).hasClass("active")) {
                show_mob_menu();
            } else {
                hide_mob_menu();
            }
        }
    });

    // aos_init();

    $("nav a").click(function () {
        hide_mob_menu();
    })
    fixPageMinHeight();





/*
    $(".chzn-select-first").change(function () {
        $(".chzn-select-second").parent().addClass("visible");
    });
*/

    $(".btn-account-info").click(function () {
        $(this).next().finish().slideToggle();
    });

    /*
    $('.chzn-select').on('chosen:ready', function() {
        var Scrollbar = window.Scrollbar;
        Scrollbar.init(document.querySelector('.chosen-results'));
    });
    */
    $(".chzn-select").chosen({
        width: "100%"
        //disable_search: true
    });
    $(".chzn-select-search").chosen({
        width: "100%"
    });
    
    $(".chzn-select:not(.chzn-select-multiple)").change(function () {
        $(this).parent().addClass("active");
        if ( $(this).val() == "" ){
            $(this).next().children('.chosen-single').children('span').css('color','#ccc');
        }
        else {
            $(this).next().children('.chosen-single').children('span').css('color','#000');
        }
    });

    // Chosen touch support.
    /*
    if ($('.chosen-container').length > 0) {
        $('.chosen-container').on('touchstart', function(e){
          e.stopPropagation(); e.preventDefault();
          // Trigger the mousedown event.
          $(this).trigger('mousedown');
        });
      }
      */

    $(".chzn-select-multiple").chosen().on('change',function () {
        if ( $(this).val() == null ){
            $(this).parent().removeClass('active');
        }
        else{
            $(this).parent().addClass('active');
        }
        /*
        if ( $('.chzn-select-multiple + .chosen-container .chosen-drop ul.chosen-results').find('li.result-selected').length ){
            $(this).parent().addClass('active');
        }
        else{
            $(this).parent().removeClass('active');
        }
        */
       $('div').first().trigger('touchend')
       $('div').first().trigger('click')
    });




/*  for update select
    $(".chzn-select").trigger("chosen:updated");
*/


    $(".fl_inp").change(function () {
        var file = $(this)[0].files[0];
        if (file) {
            if (file.type == 'image/svg+xml' || file.type == 'image/jpeg' || file.type == 'image/png') {
                var filename = $(this).val().replace(/.*\\/, "");
                if (filename) {
                    $(this).parent().next().html(filename);
                    $(this).parent().parent().addClass('active');
                } else {
                    $(this).parent().next().html('Upload Company Logo (.png, .svg and .jpg formats)');
                }
            } else {
                $(this).parent().next().html("Wrong file extension");
                $(this)[0].value = null;
                console.log($(this));

            }
        }

    });
    
    $(".noe").on('input', function () {
        $(this)[0].value = $(this)[0].value.replace(/[^\d]/g,'').substr(0,5);
    });

    $("input[name=price]").on('input', function () {
        $(this)[0].value = $(this)[0].value.replace(/[^\d]/g,'').substr(0,6);
    });
/*    
    $("input[name=company-phone-number]").on('focus', function(){
        if(!/^\+\d*$/.test(this.value)){
            this.value = '+';
        }
    });
    
    $("input[name=company-phone-number]").on('keypress', function(e){
        if(!/\d/.test(e.key)){
            e.preventDefault();
        }else{
            this.value = this.value.substr(0,15);
        }
    });
    
    $("input[name=additional-phone-number]").on('focus', function(){
        if(!/^\+\d*$/.test(this.value)){
            this.value = '+';
        }
    });
    
    $("input[name=additional-phone-number]").on('keypress', function(e){
        if(!/\d/.test(e.key)){
            e.preventDefault();
        }else{
            this.value = this.value.substr(0,15);
        }
    });
*/    
    $("select[name=city]").on('click', function(e){

        if($('select[name=country]')[0].value == "") {
            
            $('select[name=country]').off();
        }
    });
    

    $('.fl_upld').on("click", "span", function () {
        $(this).parent().children('label').children('.fl_inp').html('');
        $(this).parent().children('.fl_nm').html('Upload Logo (.png, .svg and .jpg formats)');
        $(this).parent().removeClass('active');
    });


    $(".add-another-adres-btn").click(function () {
        $(this).slideUp();
        $('label.block-hidden').slideDown();
    });

    $(".my-companies-nav label.checkbox").on("click", function () {
        if ($(this).children('input').is(':checked')) {
            $(this).parents('.tabs__item2').find('.my-companies-line .checkbox input').prop('checked', true);
            //$('.my-companies-line .checkbox input').prop('checked', true);
        } else {
            $(this).parents('.tabs__item2').find('.my-companies-line .checkbox input').prop('checked', false);
            //$('.my-companies-line .checkbox input').prop("checked", false);
        }
    });

    $(".payment-row").on("click", ".directoryItem", function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $('.payment-row .directoryItem').removeClass('active');
            $(this).addClass('active');
        }
    });








    // end ready
});

var windowLoad = false;
$(window).load(function () {
    windowLoad = true;
});

function move_to_tablet() {

};


function move_to_desktop() {
    hide_mob_menu();
    // if (typeof popup != 'undefined') popup.hide();
};

function prefix(val) {
    return val < 10 ? '0' : ''
};

function countPrefix(index) {
    return index < 10 ? "0" + index : index;
};

function show_mob_menu(time = 500) {
    var total_delay = 200;
    $("header .mobile_row nav li, header .bookDemo, header .lang").each(function (i) {
        $(this).css("transition-delay", total_delay + "ms").attr("data-delay", total_delay);
        total_delay += 100;
    });
    // 
    hold_scroll_page(true);
    $("header").addClass("show  white");
    setTimeout(() => {
        $("header").addClass("open");
    }, 50);
    setTimeout(() => {
        menu_btn_access = true;
    }, time);
}

function hide_mob_menu(time = 500) {
    hold_scroll_page(false);
    $("header").removeClass("open white");
    setTimeout(function () {
        $("header").removeClass("show");
        menu_btn_access = true;
        $("header nav li, header .tel_block").removeAttr("data-delay")
    }, 700);
    $(".menu_btn").removeClass("active")
}

function navClick(i) {
    $('body, html').animate({
        scrollTop: $('.screen').eq(i).offset().top - $("header").innerHeight()
    }, 1000);
    hide_mob_menu();
}

function getScrollbarWidth() {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);
    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);
    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
}

function detectIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }
    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }
    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }
    // other browser
    return false;
}
if (detectIE()) {
    // do somethin
}

function showMoreNewsItemCard() {
    $(".newsGrid.main").append($(".newsGrid.hidden .newsItemCard"));
    let newsGridMain = $(".newsGridBlock .newsGrid.main");
    let newsGridHidden = $(".newsGridBlock .newsGrid.hidden");
    let loadBtn = $(".newsGridBlock .loadMore .mainBtn");
    if (loadBtn.hasClass("loading")) return false;
    // 
    loadBtn.addClass("loading").attr("disabled", 'disabled');
    // этот блок замени на ajax
    setTimeout(() => {
        // temp
        let tempCards = newsGridMain.find(".newsItemCard").slice(0, 10).clone();
        tempCards.fadeTo(0, 0);
        // хочу что бы карточки появлялись через fade
        newsGridMain.append(tempCards.fadeTo(150, 1));
        // temp
        loadBtn.removeClass("loading").removeAttr("disabled")
    }, 1000)
}

function scrollTo(block, scrollTop, time = 1) {
    TweenMax.to(block, time, {
        scrollTop: scrollTop,
        ease: "Power2.easeInOut",
    });
};


const aosFadeArrDone = [
    '.parallaxDotsItem:not(.custom)'
];

function aos_init() {
    $(".aos").attr("data-aos", "fade-up");
    $(aosFadeArrDone.join(',')).addClass("aos").attr("data-aos", "fade-up");
    setTimeout(() => {
        AOS.init({
            duration: 500,
            once: true,
            easing: "ease-out-quad"
        });
    }, 500);
};

function initPopupVideo() {
    let video_html = $("#video_html");
    if (video_html.find("video").length) {
        $("#popupVideo")[0].play();
        return false;
    }
    let videoSrc = video_html.data("src");
    let poster = video_html.data("poster");
    let video = `<video loop autoplay id="popupVideo" controls poster="${poster}">
                    <source src="${videoSrc}" type='video/mp4'></source>
                </video>`;
    video_html.append(video);
    popupVideoInited = true;
}

// window.viewportUnitsBuggyfill.init({
//     force: true,
//     refreshDebounceWait: 250,
//     hacks: window.viewportUnitsBuggyfillHacks
// });

// $(document).on("click", "a:not(.dont-go)", function (e) {
//     var href = $(this).attr("href");
//     if (href.indexOf("void(0)") < 0 && href.length && $(this).attr("target") != "_blank") {
//         e.preventDefault();
//         $("body").fadeTo(250, 0, function () {
//             window.location.href = href;
//         })
//     }
// });
function setDelayTransform(divs, total_delay = 300) {
    $(divs).each(function (i) {
        $(this).css("transition-delay", total_delay + "ms").attr("data-delay", total_delay);
        total_delay += 100;
    });
}

function fixPageMinHeight() {
    if (typeof wrapper == 'undefined') wrapper = $(".wrapper");
    if (typeof header == 'undefined') header = $("header");
    if (typeof footer == 'undefined') footer = $("footer");

    let height = window_height - footer.innerHeight() - parseInt(footer.css("margin-top"));
    if (window_width > 991) height -= header.innerHeight();
    wrapper.css('min-height', height);
}


